module.exports = __webpack_public_path__ + "static/ic-menu-immunity-passport-21e7df8f6149012f3042b5074704c69c.svg";